<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Virology
    </template>
    <template #body>
      <b> {{ virologyList.length }} results found: </b> 
     
      <div class="sections">
        <div v-if="virologyList.length === 0">
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Test Result"
              />
            </div>
            <!-- <div class="col-2">
           <div class="fieldName">
             Test Result 
           </div>
           <input
             class="inputDisplay"
             disabled
           >
         </div>  -->

            <div class="col-2">
              <ADSTextInput
                disabled
                label="Sample Code"
              />
            </div>

            <!-- <div class="col-2">
           <div class="fieldName">
             Sample Code
           </div>
           <input
             class="inputDisplay"
             disabled
           >
         </div> -->


            <div class="col-2">
              <ADSTextInput
                disabled
                label="laboratory"
              />
            </div>

            <!-- <div class="col-4">
           <div class="fieldName">
             Comments
           </div>
           <input
             class="inputDisplayComments"
             disabled
           >
         </div> -->
          </div>

          <div class="row">
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Sample Date"
              />
            </div>
            <!-- <div class="col-2">
           <div class="fieldName">
             Sample Date
           </div>
           <input
             class="inputDisplay"
             disabled
           >
         </div>  -->

            <div class="col-2">
              <ADSTextInput
                disabled
                label="Sample Time"
              />
            </div>

            <!-- <div class="col-2">
           <div class="fieldName">
             Sample Time
           </div>
           <input
             class="inputDisplay"
             disabled
           >
         </div> -->

            <div class="col-2">
              <ADSTextInput
                disabled
                label="Test Date"
              />
            </div>

            <!-- <div class="col-2">
           <div class="fieldName">
             Test Date
           </div>
           <input
             class="inputDisplay"
             disabled
           >
         </div> -->

            <div class="col-2">
              <ADSTextInput
                disabled
                label="Test Time"
              />
            </div>

            <!-- <div class="col-2">
           <div class="fieldName">
             Test Time
           </div>
           <input
             class="inputDisplay"
             disabled
           >
         </div> -->
          </div>
        </div>
        <div
          v-for="( item, index ) in virologyList"
          :key="item"
        >
          <!-- <br> -->
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                v-model="item.testResult"
                disabled
                :label="`Test Result ${index + 1}`"
              />
            </div>
      

            <div class="col-2">
              <ADSTextInput
                v-model="item.sampleCode"
                disabled
                label="Sample Code"
              />
            </div>

       

            <div
              v-if="patientType === 'Donor'" 
              class="col-8"
            >
              <ADSTextAreaInput
                id="default-textarea"
                v-model="item.laboratory"
                class="comments"
                disabled
                label="Laboratory"
              />
            </div>
          </div>

          <div class="row">
            <div
              v-if="patientType === 'Recipient'"
              class="col-2"
            >
              <ADSTextInput
                v-model="item.testDate"
                disabled
                label="Sample Date"
              />
            </div>

            <div
              v-if="patientType === 'Recipient'"
              class="col-2"
            >
              <ADSTextInput
                v-model="item.testDate"
                disabled
                label="Sample Time"
              />
            </div>


            <div class="col-2">
              <ADSTextInput
                v-model="item.testDate"
                disabled
                label="Test Date"
              />
            </div>


            <div class="col-2">
              <ADSTextInput
                v-model="item.testDate"
                disabled
                label="Test Time"
              />
            </div>
          </div>
          <hr class="lineBreak">
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';
import { RECIPIENT_VIROLOGY_LOIN_CODES, RECIPIENT_VIROLOGY_CODES_MAPPING, LIVING_DONOR_VIROLOGY_CODES_MAPPING } from "@/constants";

export default {
  name: "VirologySectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    patientType:{
      type: String,
      default: null
    },
  },
  data() {
    return {
      // testResult: this.getCMVIGGAB( this.patientBundle ),
      // comments: this.getComments( this.patientBundle ),
      // testDate: this.getTestDate( this.patientBundle ),
      // sampleDate: this.getTestDate( this.patientBundle ),
      // sampleCode: this.getSampleCode( this.patientBundle ),
      virologyList: this.getVirologyList( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getVirologyList( patientBundle ) {


      if ( this.patientType === 'Recipient' ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'laboratory' ) );
      if ( observation && observation[0] ) {

        let virologyList = [];

        for ( let item of observation[0] ) {

          if ( RECIPIENT_VIROLOGY_LOIN_CODES.includes( _.get( item.resource.code, 'coding[0].code' ) ) ) {
            virologyList.push( {
              'comments': _.get( item.resource, 'note[0].text', '' ) + _.get( item, 'resource.code.text', '' ), 'testResult': _.get( item, 'resource.valueString', '' ) ? _.get( item, 'resource.valueString', '' ) : _.get( item, 'resource.valueQuantity.value', '' ) , 'testDate': _.get( item, 'resource.effectiveDateTime', '' )?.substring( 0, 10 ),
              'sampleCode': this.getSampleCode( _.get( item.resource.code, 'coding[0].code' ) )
            } );
          }
        }
        return virologyList;
      }
      else
        return [];
      }
      else {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let labTestTime
        let testTime = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16558' ) ) ;
        if( testTime && testTime[ 0 ] ) {
        labTestTime = _.get( testTime[0], 'resource.component[0].valueDateTime' );
        }
        let laboratory;
        let labName = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16519' ) ) ;
        if( labName && labName[ 0 ] ) {
          laboratory = _.get( labName[0], 'resource.component[0].valueString' );
        }
      

        let virologyList = [];

        for ( let item of observation[0] ) {

          if ( [ 'TXP#16510', 'TXP#16511', 'TXP#16512', 'TXP#16513', 'TXP#16514', 'TXP#16515', 'TXP#16516', 'TXP#16517', 'TXP#16518' ].includes( _.get( item.resource.code, 'coding[0].code' ) ) ) {
            virologyList.push( {
              'testResult': _.get( item, 'resource.component[0].valueString', '' ), 'testDate': labTestTime, 'laboratory': laboratory,
              'sampleCode': this.getSampleCode( _.get( item.resource.code, 'coding[0].code' ) )
            } );
          }
        }
        return virologyList;
      }
      else
        return [];
      }
      
    },
    getSampleCode( code ) {
      if( this.patientType === 'Recipient' )
      return RECIPIENT_VIROLOGY_CODES_MAPPING[ code ];
      else {
        return LIVING_DONOR_VIROLOGY_CODES_MAPPING[ code ]
      }
      
    }
  },
};
</script>

<style scoped>

.card {
  /* height: 100%; */
  /* height: 450px; */
}

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 450px;
  width: 1400px;
  overflow: scroll;
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.inputDisplayComments {
  border-style: solid;
  width: 650px;
  background-color: #F2F2F2;
}

.textArea
   {
  width: 650px;
  height: 50px;
  background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

.lineBreak {
  /* color: black;
  height: 2px; */
  background-color: rgb(59, 53, 53);
  border: 0 none;
    /* color: black; */
  height: 5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.comments .afflo-ds-form-control) {
  width: 500px;
}

</style>
